export const PARTNER_COLUMNS = [
  { key: "name", header: "Emërtimi *", width: 35 },
  { key: "identification", header: "Numri identifikues *", width: 26 }, { key: "vat", header: "Numri i TVSH-së", width: 24 },
  { key: "address", header: "Adresa *", width: 35 }, { key: "state", header: "Shteti *", width: 25 },
  { key: "city", header: "Qyteti *", width: 25 }, { key: "bank", header: "Banka", width: 30 },
  { key: "bankAccount", header: "Llogaria bankare", width: 28 }, { key: "phone", header: "Telefoni", width: 25 },
  { key: "email", header: "Email", width: 32 }, { key: "comment", header: "Koment", width: 40 },
];
export const partnerName = value => String(value ?? "").trim().replace(/\s+/g, " ").toLocaleLowerCase("sq");

export function partnerLookupIndexes(lookups) {
  const build = (rows, key) => {
    const index = new Map();
    rows.forEach(item => { const name = key(item); if (!index.has(name)) index.set(name, []); index.get(name).push(item); });
    return index;
  };
  return {
    states: build(lookups.states, item => partnerName(item.StateName)),
    cities: build(lookups.cities, item => `${item.StateID}:${partnerName(item.CityName)}`),
    banks: build(lookups.banks, item => partnerName(item.BankName)),
  };
}

export function validatePartnerRow(row, indexes) {
  const errors = { ...row.sourceIssues };
  const resolved = {};
  const ledgerIds = [...new Set(row.ledgerIds || [])];
  if (!ledgerIds.length || ledgerIds.some(id => ![105, 302].includes(id))) errors.roles = "Caktoni Klient, Furnitor ose të dyja në tabelë.";
  if (!String(row.name || "").trim()) errors.name = "Emërtimi është i detyrueshëm.";
  if (!String(row.address || "").trim()) errors.address = "Adresa është e detyrueshme.";
  const identification = String(row.identification || "").trim();
  if (!identification || identification.length > 15) errors.identification = "Numri identifikues është i detyrueshëm, deri në 15 karaktere.";
  if (String(row.vat || "").trim().length > 15) errors.vat = "Numri i TVSH-së lejohet deri në 15 karaktere.";
  const resolve = (field, choices, idField, required) => {
    if (!String(row[field] || "").trim()) { if (required) errors[field] = "Plotësoni këtë fushë nga lista e Accountree."; return; }
    const candidates = choices || [];
    const overridden = candidates.find(item => Number(item[idField]) === Number(row.lookupOverrides?.[field]));
    const unique = new Map(candidates.map(item => [Number(item[idField]), item]));
    if (overridden) resolved[field] = Number(overridden[idField]);
    else if (unique.size === 1) resolved[field] = [...unique.keys()][0];
    else errors[field] = unique.size ? "Emri ka disa përputhje. Zgjidhni vlerën e saktë në tabelë." : "Emri nuk u gjet në listën përkatëse të Accountree.";
  };
  resolve("state", indexes.states.get(partnerName(row.state)), "StateID", true);
  resolve("city", indexes.cities.get(`${resolved.state}:${partnerName(row.city)}`), "CityID", true);
  resolve("bank", indexes.banks.get(partnerName(row.bank)), "BankID", false);
  const bankAccount = String(row.bankAccount || "").replace(/[\s-]/g, "");
  if (bankAccount && !/^\d{16}$/.test(bankAccount)) errors.bankAccount = "Llogaria bankare duhet të ketë saktësisht 16 shifra.";
  resolved.bankAccount = bankAccount;
  if (row.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(row.email).trim())) errors.email = "Shënoni email të vlefshëm ose lëreni bosh.";
  resolved.active = true;
  return { ...row, ledgerIds, resolved, errors };
}

export function partnerDuplicateKeys(rows) {
  const counts = new Map();
  rows.forEach(row => {
    if (!String(row.identification || "").trim()) return;
    [...new Set(row.ledgerIds || [])].forEach(ledgerId => {
      const key = `${ledgerId}:${partnerName(row.identification)}`;
      counts.set(key, (counts.get(key) || 0) + 1);
    });
  });
  return counts;
}

// Produces one prospective Accounts record per assigned role, without copying source rows in memory.
export function* getPartnerInsertRows(rows) {
  for (const row of rows) {
    for (const ledgerId of [...new Set(row.ledgerIds || [])]) {
      if (![105, 302].includes(ledgerId)) throw new Error("Lloji i partnerit është i pavlefshëm.");
      yield { ExcelRow: row.excelRow, AccountName: String(row.name || "").trim(), LedgerID: ledgerId,
        IdentificationNumber: String(row.identification || "").trim(), VATNumber: row.vat || "", Adress: row.address,
        StateID: row.resolved.state, CityID: row.resolved.city, BankID: row.resolved.bank ?? null,
        BankAccount: row.resolved.bankAccount, PhoneNumbers: row.phone || "", Email: row.email || "", Comment: row.comment || "", IsActive: true };
    }
  }
}
